import * as React from 'react';
import type { SVGProps } from 'react';

interface SVGRProps {
  title?: string;
  titleId?: string;
}

const SvgInklapbaar = ({ title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    width={24}
    height={24}
    viewBox='0 0 24 24'
    xmlns='http://www.w3.org/2000/svg'
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fill='currentColor'
      d='M14.2937 12.02L18.1537 8.16C18.3437 7.96 18.6637 7.96 18.8537 8.16C19.0437 8.36 19.0537 8.67 18.8537 8.86L15.7037 12.01L18.8437 15.16C19.0437 15.36 19.0437 15.67 18.8437 15.87C18.6437 16.07 18.3337 16.07 18.1337 15.87L14.2837 12.02L14.2937 12.02Z'
    />
    <path
      fill='currentColor'
      d='M5.00373 15.51C5.00373 15.38 5.05373 15.25 5.15373 15.16L8.30373 12.01L5.16373 8.86C4.96373 8.66 4.96373 8.35 5.16373 8.15C5.36373 7.95 5.67373 7.95 5.87373 8.15L9.72373 12L5.86373 15.86C5.66373 16.06 5.35373 16.06 5.15373 15.86C5.05372 15.76 5.00373 15.63 5.00373 15.51Z'
    />
  </svg>
);

export default SvgInklapbaar;
